import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  padding: 12px 0;
  display: grid;
`;
